<div class="bg-secondary text-body" data-bs-theme="dark" style="--bs-body-bg: var(--bs-secondary);">
  <div class="container">
    <div class="d-flex align-items-center justify-content-between gap-4 py-3">
      <!-- - - - Social Media & Contact - - - -->
      <div class="d-flex align-items-center gap-4">
        <a href="https://www.facebook.com/hakikatev" rel="noopener noreferrer" target="_blank" aria-label="Facebook page" i18n-aria-label>
          <fa-icon [icon]="['fab', 'facebook']" />
        </a>
        <a href="https://www.instagram.com/hakikatev" rel="noopener noreferrer" target="_blank" aria-label="Instagram page" i18n-aria-label>
          <fa-icon [icon]="['fab', 'instagram']" />
        </a>
        <a href="https://www.tiktok.com/@hakikatev" rel="noopener noreferrer" target="_blank" aria-label="TikTok page" i18n-aria-label>
          <fa-icon [icon]="['fab', 'tiktok']" />
        </a>
        <span class="text-body opacity-50">|</span>
        <a class="icon-link gap-2 link-body-emphasis text-decoration-none" href="tel:" type="phone" aria-label="Phone Number" i18n-aria-label>
          <fa-icon [icon]="iconPhone" size="sm" />
          <small>+49 6105 - 717 6116</small>
        </a>
      </div>

      <!-- - - - Localization & Authentication - - - -->
      <div class="d-flex align-items-center gap-4">
        <app-localize />
        <span class="text-body opacity-50">|</span>
        <app-auth />
      </div>
    </div>
  </div>
</div>